// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1wIEU","displayFlex":"styles_displayFlex__2Hoaz","svg":"styles_svg__2MYAZ","svgDiv":"styles_svgDiv__WeL0_"};